
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Initialize the root element with error handling
try {
  const rootElement = document.getElementById("root");
  if (rootElement) {
    createRoot(rootElement).render(<App />);
  } else {
    console.error("Root element not found");
  }
} catch (error) {
  console.error("Failed to render application:", error);
  // Display a fallback error message to the user
  document.body.innerHTML = `
    <div style="font-family: system-ui; padding: 2rem; text-align: center;">
      <h1>Something went wrong</h1>
      <p>The application couldn't be loaded. Please try refreshing the page.</p>
    </div>
  `;
}
